import React, { useEffect } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import TopBar from "../components/dashboardParts/TopBar";
import { currentUser } from "system/InfegyUser";
import { DashboardListContent } from "components/widgets/lists/DashboardList/DashboardList";
import {TemplateSearchWidgetContent} from "components/widgets/utility/TemplateSearch/TemplateSearch";
import StartPageResources from "components/dashboardParts/StartPageResources";
import { setDocumentTitle } from "system/Utilities";

export default function StartPage(): JSX.Element {
  const { i18n } = useTranslation();
  const user = currentUser();

  const canSubmitQueries = user?.permissions?.includes("run_query");

  // Sets document title to default "Infegy Starscape"
  useEffect(() => setDocumentTitle(), []);

  return (
    <Box sx={{ maxWidth:"1300px", margin:"0 auto", position:"relative", pl: 2, pr: 2 }}>
      <TopBar title={`${i18n.t("home.greeting")} ${currentUser()?.name}!`} showLogo={true} ></TopBar>
      {canSubmitQueries &&
        <Box>
          <Typography variant="h3" sx={{ textAlign:"left", mt:3, mb:1, fontWeight: "600", opacity: 0.8 }}>
            {i18n.t("quick-search")}
          </Typography>
          <Paper sx={{mb: 6}}>
            <TemplateSearchWidgetContent></TemplateSearchWidgetContent>
          </Paper>
        </Box>
      }
      <Box sx={{ display: {md: "grid", sm: "block"}, gridTemplateColumns: "auto 350px", columnGap: "2em"}}>
        <Box>
          <Typography variant="h3" sx={{ textAlign:"left", mb: 1, fontWeight: "600", opacity: 0.8 }}>
            {i18n.t("dashboards")}
          </Typography>
          <Paper>
            <DashboardListContent></DashboardListContent>
          </Paper>
        </Box>
        <Box>
          <Typography variant="h3" sx={{ textAlign:"left", mb: 1, mt:{md:"inherit", sm: 3}, fontWeight: "600", opacity: 0.8 }}>
            {i18n.t("start-page.helpful-links")}
          </Typography>
          <StartPageResources></StartPageResources>
        </Box>
      </Box>
    </Box>
  );
}